import script from "./MdmToolsConfigEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MdmToolsConfigEditor.vue?vue&type=script&setup=true&lang=js"

import "./MdmToolsConfigEditor.vue?vue&type=style&index=0&id=1b0cda39&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b0cda39"]])

export default __exports__